<template lang="pug">
  #ReservationIndex
    h5.text-center.pt-2 我的顧客
    .p-3
      b-row(
        no-gutters
        class="mb-3"
      )
        b-col(
          cols=4,
          class="d-flex align-items-center"
        )
          ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
            :profileUrl="memberInfo.img",
            :style="{ 'width': '80px', 'height': '80px' }"
          )
        b-col(
          cols=8
        )
          p.mb-1.font-weight-bold Johhny
          p.mb-0 LINE暱稱：{{ memberInfo.name }}
          p.mb-0.d-flex.align-items-center
            span(
              style="flex: 0 0 auto;"
            ) 備註名：
            b-input.d-inline-block(
              v-model="memberInfo.noteName",
              :disabled="!editMode"
            )
            b-button.rounded-50.d-flex.align-items-center.justify-content-center.mx-2.button.iconBtn.iconEditBtn(
              variant="primary",
              @click="editModeHandler()"
            )
              i.fas.fa-pencil-alt.iconEdit
      b-row(
        no-gutters
        class="mb-3 px-2 button-row"
      )
        b-col(
          cols=6
        )
          b-button.button-first(
            block,
            :variant=" nowSelectItem === '客戶資料' ? 'primary' : 'outline-primary' ",
            @click="changeTypeHandler('客戶資料')"
          ) 客戶資料
        b-col(
          cols=6
        )
          b-button.button-last(
            block,
            :variant=" nowSelectItem === '預約紀錄' ? 'primary' : 'outline-primary' ",
            @click="changeTypeHandler('預約紀錄')"
          ) 預約紀錄
      .customerInfo.px-3(
        v-show="nowSelectItem === '客戶資料'"
      )
        p.mb-1 綁定日期：{{ memberInfo.bind_at }}
        p.mb-1 顧客描述：
        b-textarea(
          v-model="memberInfo.description",
          class="mb-2"
        )
        .text-center
          b-button(
            size="sm",
            variant="primary",
            @click="updateDescriptionHandler()"
          ) 更新
        hr.my-4
        p.mb-1 客戶標籤：
        multiselect(
          v-model="memberInfo.labels",
          tag-placeholder="新增標籤",
          placeholder="輸入文字新增標籤",
          selectLabel="點擊新增標籤",
          deselectLabel="點擊移除標籤",
          selectedLabel="已選擇",
          label="label",
          track-by="label"
          :options="labelsOptions",
          :multiple="true",
          :taggable="true",
          @tag="addLabelHandler",
          @remove="removeLabelHandler"
          noOptions="無標籤"
        )
          template(slot="Label", slot-scope='{ labelsOptions }')
          strong {{ labelsOptions.label }}
          template(slot="noOptions")
            strong 請按 Enter 新增標籤
        small.d-block.w-100.mt-1.text-muted 直接在上方欄位輸入新標籤後點選新增標籤即可新增標籤
        small.d-block.w-100.text-muted 新增完成後需再
          code 手動選擇新標籤
          | 才會替顧客加上標籤
      .reservationInfo(
        v-show="nowSelectItem === '預約紀錄'"
      )
        b-row(
          no-gutters
          class="mb-3"
        )
          b-col(
            cols=3,
            class="pr-1"
          )
            b-button.h-100(
              block,
              :variant=" nowSelectStatus === '已預約' ? 'primary' : 'outline-primary' ",
              @click="changeStatusHandler('已預約')"
            ) 已預約
          b-col(
            cols=3,
            class="pr-1"
          )
            b-button.h-100(
              block,
              :variant=" nowSelectStatus === '確認中' ? 'primary' : 'outline-primary' ",
              @click="changeStatusHandler('確認中')"
            ) 確認中
          b-col(
            cols=3,
            class="pr-1"
          )
            b-button.h-100(
              block,
              :variant=" nowSelectStatus === '預約完成' ? 'primary' : 'outline-primary' ",
              @click="changeStatusHandler('預約完成')"
            ) 預約完成
          b-col(
            cols=3
          )
            b-button.h-100(
              block,
              :variant=" nowSelectStatus === '已過期' ? 'primary' : 'outline-primary' ",
              @click="changeStatusHandler('已過期')"
            ) 已過期
        b-card.border-0.mb-2.customerCard.overflow-hidden(
          bg-variant="light",
          v-for="(reservation,index) in filterReservationList",
          :key="reservation.id"
        )
          .reserveAtRow.mb-2.d-flex.align-items-center
            i.far.fa-calendar-check.mr-2
            small 預約時間：{{ reservation.reserve_at }}
          .typeRow.mb-2.d-flex.align-items-center
            i.fas.fa-border-all.mr-2
            small 服務內容：{{ reservation.reserve_name }}
          .statusRow.mb-2.d-flex.align-items-center
            i.far.fa-check-circle.mr-2
            small 預約狀態：{{ reservation.status === 0 ? '已預約' : reservation.status === 1 ? '確認中' : reservation.status === 2 ? '預約完成' : reservation.status === 3 ? '已過期' : '-' }}
          .labelRow.d-flex.align-items-center.flex-wrap.mb-3
            i.fas.fa-tag.mr-2
            small 顧客標籤：
            b-badge.m-1.rounded-50.px-3.py-2(
              variant="primary",
              v-for="label in reservation.labels"
              :key="label.id"
            ) {{ label.label }}
          b-row(
            no-gutters
          )
            b-col(
              cols=6,
              class="d-flex justify-content-end pr-1",
              v-if="reservation.status === 0 || reservation.status === 1"
            )
              b-button(
                size="sm",
                variant="primary",
                @click="cancelReservationHandler(reservation.id)"
              ) 取消預約
            b-col(
              cols=6,
              class="pl-1",
              v-if="reservation.status === 0"
            )
              b-button(
                size="sm",
                variant="primary",
                @click="editReservationHandler(reservation.id)"
              ) 修改預約
            b-col(
              cols=6,
              class="pl-1",
              v-if="reservation.status === 1"
            )
              b-button(
                size="sm",
                variant="primary",
                @click="confirmReservationHandler(reservation.id)"
              ) 預約確認
          .labelTag(
            v-if="reservation.status === 3",
            style="right: 0;bottom: 0;"
          )
            span.labelTag__text 已過期
</template>

<script>
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import { SM_MY_CUSTOMER_RESERVATION_EDIT } from '@/router/sm/my-customer';

// 測試圖片
import memberExUrl from '@/assets/images/example/sa_2.png';

export default {
  name: 'ReservationIndex',
  components: {
    ProfilePhotoSticker
  },
  props: {
    userId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      nowSelectItem: '客戶資料',
      nowSelectStatus: '已預約',
      memberInfo: {
        name: 'Ariby',
        nickName: '中實戶',
        noteName: null,
        img: memberExUrl,
        bind_at: '2020/07/01',
        description: null,
        labels: [
          {
            id: 0,
            label: '美白'
          },
          {
            id: 1,
            label: 'VIP'
          },
          {
            id: 2,
            label: '難搞客戶'
          }
        ]
      },
      editMode: false,
      reservationList: [
        {
          id: 0,
          reserve_at: '2020/06/29 18:30',
          reserve_name: '產品諮詢',
          status: 0,
          labels: [
            {
              id: 0,
              label: '美白'
            },
            {
              id: 1,
              label: 'VIP'
            }
          ]
        },
        {
          id: 1,
          reserve_at: '2020/06/25 11:30',
          reserve_name: '產品諮詢',
          status: 1,
          labels: [
            {
              id: 1,
              label: 'VIP'
            }
          ]
        },
        {
          id: 2,
          reserve_at: '2020/02/12 08:00',
          reserve_name: '客訴',
          status: 3,
          labels: [
            {
              id: 1,
              label: '難搞客戶'
            }
          ]
        }
      ],
      labelsOptions: [
        {
          id: 0,
          label: '美白'
        },
        {
          id: 1,
          label: 'VIP'
        },
        {
          id: 2,
          label: '難搞客戶'
        }
      ]
    };
  },
  mounted() {
    this.$store.commit('toggleLoading', false);
    console.log(this.userId);
  },
  methods: {
    changeTypeHandler(type) {
      const vm = this;
      console.log(type, vm.nowSelectItem);
      switch (type) {
        case '客戶資料':
          if (vm.nowSelectItem === '客戶資料') return;
          vm.nowSelectItem = '客戶資料';
          break;
        case '預約紀錄':
          if (vm.nowSelectItem === '預約紀錄') return;
          vm.nowSelectItem = '預約紀錄';
          break;
        default:
          break;
      }
    },
    changeStatusHandler(type) {
      const vm = this;
      switch (type) {
        case '已預約':
          if (vm.nowSelectStatus === '已預約') return;
          vm.nowSelectStatus = '已預約';
          break;
        case '確認中':
          if (vm.nowSelectStatus === '確認中') return;
          vm.nowSelectStatus = '確認中';
          break;
        case '預約完成':
          if (vm.nowSelectStatus === '預約完成') return;
          vm.nowSelectStatus = '預約完成';
          break;
        case '已過期':
          if (vm.nowSelectStatus === '已過期') return;
          vm.nowSelectStatus = '已過期';
          break;
        default:
          break;
      }
    },
    editModeHandler() {
      const vm = this;

      if (!vm.editMode) {
        vm.editMode = true;
      } else {
        vm.$swal.fire({
          title: '備註名儲存中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            vm.$swal.showLoading();
          }
        });
        setTimeout(() => {
          // TODO: 修改備註名完成
          vm.$swal.close();
          vm.editMode = false;
        }, 2000);
      }
    },
    cancelReservationHandler(reservationId) {
      console.log('取消預約', reservationId);
    },
    editReservationHandler(reservationId) {
      console.log('修改預約', reservationId);
      const vm = this;
      vm.$router.push({
        name: SM_MY_CUSTOMER_RESERVATION_EDIT,
        params: {
          userId: vm.userId,
          id: reservationId
        }
      });
    },
    confirmReservationHandler(reservationId) {
      console.log('預約確認', reservationId);
    },
    updateDescriptionHandler() {
      console.log('更新顧客描述');
    },
    addLabelHandler(label) {
      console.log('新增標籤', label);
      const vm = this;
      vm.labelsOptions.push({
        id: vm.labelsOptions.length,
        label
      });
    },
    removeLabelHandler(label) {
      console.log('移除標籤', label);
      const vm = this;
    }
  },
  computed: {
    filterReservationList() {
      const vm = this;
      if (vm.nowSelectStatus === '已預約') {
        return vm.reservationList.filter((reserve) => reserve.status === 0);
      } if (vm.nowSelectStatus === '確認中') {
        return vm.reservationList.filter((reserve) => reserve.status === 1);
      } if (vm.nowSelectStatus === '預約完成') {
        return vm.reservationList.filter((reserve) => reserve.status === 2);
      } if (vm.nowSelectStatus === '已過期') {
        return vm.reservationList.filter((reserve) => reserve.status === 3);
      }
        return [];
    }
  }
};
</script>

<style>

</style>
